
import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import MuiAccordion from '@material-ui/core/Accordion';
import MuiAccordionSummary from '@material-ui/core/AccordionSummary';
import MuiAccordionDetails from '@material-ui/core/AccordionDetails';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import SubMenuCards from './SubMenuCards';

import platformSE from '../Data/PlatformS&PE.json'
import platformSAPFDE from '../Data/PlatformSAPFDE.json'
import CloudFirst from '../Data/PlatformCloudFirstFDE.json'
import IEFDE from '../Data/IEFDE.json'
import SalesforceFDE from '../Data/SalesforceFDE.json'
import AdobeFDE from '../Data/AdobeFDE.json'
import OracleFDE from '../Data/OracleFDE.json'
import LCNCFDE from '../Data/LCNC_FDE.json'
import OthersFDE from '../Data/OthersFDE.json'
import Workday from '../Data/WorkDayFDE.json'
import DataFDE from '../Data/DataFDE.json'


const Accordion = withStyles({
  root: {
    border: '1px solid rgba(0, 0, 0, .125)',
    boxShadow: 'none',
    '&:not(:last-child)': {
      borderBottom: 0,
    },
    '&:before': {
      display: 'none',
    },
    '&$expanded': {
      margin: 'auto',
    },
  },
  expanded: {},
})(MuiAccordion);

const AccordionSummary = withStyles({
  root: {
    backgroundColor: 'rgba(0, 0, 0, .03)',
    borderBottom: '1px solid rgba(0, 0, 0, .125)',
    marginBottom: -1,
    minHeight: 56,
    '&$expanded': {
      minHeight: 56,
    },
  },
  content: {
    '&$expanded': {
      margin: '12px 0',
    },
  },
  expanded: {},
})(MuiAccordionSummary);

const AccordionDetails = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiAccordionDetails);

function CustomizedAccordionsFDE() {
  const [expanded, setExpanded] = React.useState('panel1');
  let [accordsName, setAccordsName] = React.useState('');
  const handleChange = (panel, accordName) => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false);
    setAccordsName(accordName);
  };

var streamsData = AdobeFDE
    .concat(CloudFirst)
    .concat(DataFDE)
    .concat(IEFDE)
    .concat(LCNCFDE)
    .concat(OracleFDE)
    .concat(platformSE)
    .concat(platformSAPFDE)
    .concat(SalesforceFDE)
    .concat(Workday)
    .concat(OthersFDE)
    ;

  return streamsData.filter(p => p.Display === true).map((data) => {
    return (
      <div id="stream-sec">
        <Accordion square expanded={expanded === `panel1${data.id}`} onChange={handleChange(`panel1${data.id}`, data.Name)} >
          <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel1d-content" id="panel1d-header">
            <h3>{data.Name}</h3>
          </AccordionSummary>
          <AccordionDetails>
            <SubMenuCards streams={data.streams.filter(p => p.Display === true)} AccordName={data.Default} />
          </AccordionDetails>
        </Accordion>
      </div>
    );
  });
}
export default CustomizedAccordionsFDE;